// extracted by mini-css-extract-plugin
export default {"default_task":"ProjectAssignment_default_task__YDoNo"};